import { ApiFunctionType, httpGet, httpPost, httpPostCancellable } from 'src/utils/http';
import {
  PlusSubscriptionContinueWithPlusSubscriptionPlanRequestType,
  PlusSubscriptionContinueWithPlusSubscriptionPlanResponseType,
  PlusSubscriptionContinueWithTrialPlanResponseType,
  PlusSubscriptionModalInfoResponseType,
} from 'src/models/plusSubscription';

const getPath = (path: string) => `/PlusSubscriptionPlanSelection/${path}`;

export const apiContinueWithBasicSubscription = (): Promise<void> => httpPost(getPath('ContinueWithBasicSubscription'));

export const apiContinueWithTrial = (): Promise<PlusSubscriptionContinueWithTrialPlanResponseType> =>
  httpPost(getPath('continuewithtrial'));

export const apiContinueWithPlusSubscriptionPlan: ApiFunctionType<
  PlusSubscriptionContinueWithPlusSubscriptionPlanRequestType,
  PlusSubscriptionContinueWithPlusSubscriptionPlanResponseType
> = httpPostCancellable(getPath('ContinueWithPlusSubscriptionPlan'));

export const apiGetModalInfo = (): Promise<PlusSubscriptionModalInfoResponseType> => httpGet(getPath('getmodalinfo'));
